import { useEffect, useState } from "react";

const getInitialNetworkStatus = () => {
  if (typeof navigator === "undefined") {
    return true;
  }

  return navigator.onLine;
};

export const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState<boolean>(getInitialNetworkStatus);
  const [lastChangedAt, setLastChangedAt] = useState<number | null>(null);

  useEffect(() => {
    const updateNetworkStatus = () => {
      setIsOnline(navigator.onLine);
      setLastChangedAt(Date.now());
    };

    window.addEventListener("online", updateNetworkStatus);
    window.addEventListener("offline", updateNetworkStatus);

    return () => {
      window.removeEventListener("online", updateNetworkStatus);
      window.removeEventListener("offline", updateNetworkStatus);
    };
  }, []);

  return {
    isOnline,
    hasConnectionChanged: lastChangedAt !== null,
  };
};
